import { Component, OnInit, OnDestroy, Injectable }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import {CORE_DIRECTIVES, FORM_DIRECTIVES, NgClass, NgIf} from '@angular/common';
import { IStaffingStandardsTower } from './staffing-standards-tower-list';
import { StaffingStandardsTowerService } from './staffing-standards-tower.service';

import {DataTable} from 'primeng/primeng';
import {Column} from 'primeng/primeng';
import {Header} from 'primeng/primeng';
import {Button} from 'primeng/primeng';
import {Paginator} from 'primeng/primeng';


@Component({
    //templateUrl: 'app/system-management/staffing-standards/staffing-standards-tower/staffing-standards-tower.component.html',
    template: require('./staffing-standards-tower.component.html'),
    directives: [ROUTER_DIRECTIVES,DataTable,Column, Header, Paginator],
    providers:[StaffingStandardsTowerService]
    
})

export class StaffingStandardsTowerComponent implements OnInit, OnDestroy{
    pageTitle: string = 'Staffing Standards Tower';
    errorMessage: string;
    staffingStandardsTowerArr: IStaffingStandardsTower;
    private sub: any;
    cols: any[];
    
    constructor(private route: ActivatedRoute,
                private router: Router,
                private _staffingStandardsTowerService: StaffingStandardsTowerService){
                    
    }

    ngOnInit(): void{
            this._staffingStandardsTowerService.getSSTower()
            .subscribe(
                staffingStandardsTowerArr => this.staffingStandardsTowerArr = staffingStandardsTowerArr,
                error =>  this.errorMessage = <any>error);
         this.cols = [
            {field: "locid", header: 'Locid'},
            {field: "year", header: 'Year'},
            {field: "itnAc", header: 'Air Carrier'},
            {field: "itnAt", header: 'Air Taxi'},
            {field: "itnGa", header: 'General Aviation'},
            {field: "itnMil", header: 'Military'},
            {field: "locGa", header: 'Civil'},
            {field: "locMil", header: 'Local Military'},
            {field: "totOvers", header: 'Total Overflights'},
            {field: "totOps", header: 'Total Operations'},
        ]
        //console.log('Staffing Standards Tower Component: ' +  JSON.stringify(this.cols));
    }

    ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
   
}



/** WEBPACK FOOTER **
 ** ./app/system-management/staffing-standards/staffing-standards-tower/staffing-standards-tower.component.ts
 **/